$(document).ready(function()
{
    //console.log("ready");
    //Call Foundation

    // Desktop Navigation dropdowns
    $('.menu-item-has-children').on('click', function(e) {
        e.stopPropagation();
        console.log("click")
        //e.preventBubble();
        $(this, '.dropdown').slideDown();
        $(this).toggleClass('open');
    });

    $('.menu-item-has-children.open').on('click', function(e) {
        e.stopPropagation();
        //e.preventBubble();
        $(this, '.dropdown').slideUp();
    });

    $("#menu-main-menu .current-menu-item").parents().addClass("open");
    $('#menu-main-menu .current-menu-item:has(ul)').addClass('open');

});